var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 304,
    height: 531,
    viewBox: "0 0 304 531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.11,
    y1: 0.074,
    x2: 0.889,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#291c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#5722a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#410f86"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23781",
    "data-name": "Rectangle 23781",
    d: "M0,0H304a0,0,0,0,1,0,0V379A152,152,0,0,1,152,531h0A152,152,0,0,1,0,379V0A0,0,0,0,1,0,0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/Rectangle.9a9f58eede39c08c5e5accd0f67308eb.svg";
export { ForwardRef as ReactComponent };